// TODO - Type 'any' needs to be fixed.

export const resetPublishDraftShiftsStateReducer = (state:any) => {
    state.publishDraftShiftsAsync.status = "idle";
    state.publishDraftShiftsAsync.errorMessage = "";
    state.publishDraftShiftsAsync.directAssignmentResults = [];
  }